var API_DOMAIN = "https://srivarathancrackers.com/api";

export default API_DOMAIN;
